(function () {
  'use strict';

  function factory($window) {
    'ngInject';

    return scrollTo;

    function scrollTo() {
      /* eslint-disable vars-on-top */
      var headerTop = 0;
      if (angular.element('.hq-lighting-wizard-bar').length !== 0) {
        headerTop = angular.element('.hq-lighting-wizard-bar').offset().top;
      }
      var windowScrollTop = angular.element($window).scrollTop();
      var distance = Math.abs(headerTop - windowScrollTop);

      // Move one screen height per 500ms
      var timeMultiplier = 500;
      var distanceInInnerHeights = distance / $window.innerHeight;
      var time = distanceInInnerHeights * timeMultiplier;
      angular.element('html, body').animate({ scrollTop: headerTop }, time);
      /* eslint-enable vars-on-top */
    }
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingScrollTo', factory);
}());
